export const transportInfoCardStructure = [
    {
        "sectionName": "Транспортное средство",
        "columns": [
            [
                { format: "field", caption: "Идентификатор ТС", field: "objectId", valueType: "string" },
                { format: "field", caption: "Марка ТС", field: "carBrand", valueType: "string" },
            ],
            [
                { format: "field", caption: "Гаражный номер", field: "garageNumber", valueType: "string" },
                { format: "field", caption: "Компания", field: "company", valueType: "string" },
            ],
            [
                { format: "field", caption: "Гос.номер", field: "stateNumber", valueType: "string" },
                { format: "field", caption: "Описание", field: "memo", valueType: "string" },
            ],
        ]
    }
]